import type {OutputSelector} from 'reselect';
import type {EmailSequenceTemplateGroup} from '../types';
import {Collections} from '../collections';
import type {CollectionState} from '../collections';

type EmailSequenceTemplateGroupsModuleState = {
    emailSequenceTemplateGroups: CollectionState<EmailSequenceTemplateGroup>;
};

/*
 * Given the entire redux state, pull out just the piece of state for the emailSequenceTemplateGroups reducer.
 */
const getEmailSequenceTemplateGroupsState = (state: EmailSequenceTemplateGroupsModuleState) =>
    state.emailSequenceTemplateGroups;

/*
 * Get an array of all activityTypes models
 */
export const getAll: OutputSelector<any, any, EmailSequenceTemplateGroup[]> =
    Collections.makeGetModels(getEmailSequenceTemplateGroupsState);

/*
 * Get the `byId` portion of the activityTypes state
 */
export const getById = (state: EmailSequenceTemplateGroupsModuleState) => {
    const emailSequenceTemplateGroupsState = getEmailSequenceTemplateGroupsState(state);

    return Collections.getById(emailSequenceTemplateGroupsState);
};
